import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { useSelector } from 'store';
import { spaceActions } from 'store/space';
import { GetBranchesAPI, GetAllBranchesAPI } from 'api/space';

interface IProps {
  selected: string;
}

const ClusterMenu: React.FC<IProps> = ({ selected }: IProps) => {
  const dispatch = useDispatch();
  const regions = useSelector(state => state.space.regions).results;

  useEffect(() => {
    return () => {};
  }, []);

  const clickMenu = async e => {
    const cluster = e.target.text;

    clearMenu(cluster);

    if (cluster === '전체') {
      const { data } = await GetAllBranchesAPI();
      dispatch(
        spaceActions.getBranches({
          ...data,
          region: 'ALL',
        }),
      );
    } else {
      const region = findClusterID(cluster);
      const { data } = await GetBranchesAPI(region);
      dispatch(
        spaceActions.getBranches({
          ...data,
          region: cluster,
        }),
      );
    }
  };

  const findClusterID = (cluster: string) => {
    return regions.filter(region => {
      if (region.name === cluster) return region;
    })[0].id;
  };

  const clearMenu = cluster => {
    const menu = document.getElementById('clusterMenu');
    menu.querySelectorAll('li').forEach(element => {
      const aTag = element.firstElementChild;
      if (aTag.textContent === cluster) {
        element.className = 'selected';
      } else {
        element.classList.remove('selected');
      }
    });
  };

  return (
    <div className="s-menu" id="clusterMenu">
      <ul>
        {selected === 'ALL' ? (
          <li className="selected" onClick={clickMenu}>
            <a>전체</a>
          </li>
        ) : (
          <li onClick={clickMenu}>
            <a>전체</a>
          </li>
        )}
        {regions.map(region => {
          if (region.name === selected) {
            return (
              <li key={region.id} className="selected" onClick={clickMenu}>
                <a>{region.name}</a>
              </li>
            );
          }
          return (
            <li key={region.id} onClick={clickMenu}>
              <a>{region.name}</a>
            </li>
          );
        })}
      </ul>
    </div>
  );
};

export default ClusterMenu;
